// extracted by mini-css-extract-plugin
export default {"order_cards":"dashboard_order_cards__L+6JF","table_main_container":"dashboard_table_main_container__mPHp5","table_main_container_error":"dashboard_table_main_container_error__qEprq"};